module.exports = __webpack_public_path__ + "static/media/FT-FONDO-AR.36f8b245.jpg";